import { Router } from '@angular/router';
import { Auth } from 'aws-amplify';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
var AuthGuardService = /** @class */ (function () {
    function AuthGuardService(router) {
        this.router = router;
    }
    AuthGuardService.prototype.canActivate = function (next, state) {
        var _this = this;
        return Auth.currentAuthenticatedUser()
            .then(function (user) {
            return true;
        })
            .catch(function (error) {
            // Preserve the full URL (including query parameters) as returnUrl
            var returnUrl = state.url;
            _this.router.navigate(['/login'], {
                queryParams: { returnUrl: returnUrl }
            });
            return false;
        });
    };
    AuthGuardService.prototype.canActivateChild = function (route, state) {
        return this.canActivate(route, state);
    };
    AuthGuardService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthGuardService_Factory() { return new AuthGuardService(i0.ɵɵinject(i1.Router)); }, token: AuthGuardService, providedIn: "root" });
    return AuthGuardService;
}());
export { AuthGuardService };
